var moment = require('moment');

function hasDateValue(value) {
  return value !== null && typeof value !== 'undefined' && value !== '';
}

function toMoment(value) {
  if (moment.isMoment(value)) {
    return value.clone();
  }
  return moment(value);
}

function expirationForOrigin(originValue) {
  var originDate = toMoment(originValue);
  if (!originDate.isValid()) return null;
  return originDate.clone().add(1, 'year');
}

function setExpirationFromOrigin(model, originValue) {
  var expirationDate = expirationForOrigin(originValue);
  if (!expirationDate || !model.form || !model.form.expirationDate) return;
  model.form.expirationDate(expirationDate);
}

function applyInitialCertificateDates(model, record) {
  if (!model.form || !model.form.originDate || !model.form.expirationDate) return;

  var originValue = model.form.originDate();
  if (!hasDateValue(originValue)) {
    originValue = moment();
    model.form.originDate(originValue);
  }

  var expirationValue = model.form.expirationDate();
  if (!hasDateValue(expirationValue)) {
    setExpirationFromOrigin(model, originValue);
  }

  model.expirationDateEdited = hasDateValue(record && record.expirationDate);
}

function handleOriginDateChange(model, originValue) {
  if (model.expirationDateEdited) return;
  setExpirationFromOrigin(model, originValue);
}

function handleExpirationDateChange(model) {
  model.expirationDateEdited = true;
}

function configureInstrumentCertificateDates(model) {
  if (!model || model.__instrumentCertificateDatesConfigured) return model;

  var baseInitForm = model.initForm;
  model.initForm = function (record, options) {
    baseInitForm.call(model, record, options);
    applyInitialCertificateDates(model, record);
  };

  model.fields.originDate.onchange = function (originValue) {
    handleOriginDateChange(model, originValue);
  };

  model.fields.expirationDate.onchange = function () {
    handleExpirationDateChange(model);
  };

  model.__instrumentCertificateDatesConfigured = true;
  return model;
}

module.exports = {
  applyInitialCertificateDates: applyInitialCertificateDates,
  configureInstrumentCertificateDates: configureInstrumentCertificateDates,
  expirationForOrigin: expirationForOrigin,
  handleExpirationDateChange: handleExpirationDateChange,
  handleOriginDateChange: handleOriginDateChange
};
